module.exports = __webpack_public_path__ + "static/media/Technologyicon03@2x.7eef30ff.png";